import { IApplicationState } from '../types/redux';
import { hasValidPhone } from '../utils/agent';

export const sellersSelector = (state: IApplicationState) => {
  return state.newbuilding.sellers;
};

export function sellersWithPhonesSelector(state: IApplicationState) {
  const {
    newbuilding: { sellers },
  } = state;

  if (sellers) {
    return sellers.filter(seller => seller.showPhone && seller.phone);
  }

  return [];
}

export function sellersWithValidPhonesSelector(state: IApplicationState) {
  const sellers = sellersSelector(state);

  return sellers.filter(hasValidPhone);
}
